var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('div',{ref:"polygonRef",staticClass:"polygonView",style:({
          width: _vm.imgSize.width + 'px',
          height: _vm.imgSize.height + 'px',
          backgroundImage: 'url(' + _vm.base64Str + ')',
        })})]),(_vm.showLabels)?_c('v-col',[_c('v-virtual-scroll',{attrs:{"items":_vm.data,"item-height":50,"height":_vm.imgSize.height + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var item = ref.item;
        var index = ref.index;
return [_c('div',{staticClass:"polygon",on:{"mouseover":function () { return _vm.focusPolygon(index); },"mouseleave":function () { return _vm.unfocusPolygon(index); }}},[_vm._v(" "+_vm._s(item.name)+" ")])]}}],null,false,2021428223)})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }